import axios from 'axios'
import { Accrual, PostAccrual, UpdateAccrual } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

// GET: /Accrual - Get all accruals
export const getAccruals = async (): Promise<Accrual[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/Accrual`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: Accrual[] = response.data
  return data
}

// GET: /Accrual/{id} - Get single accrual by ID
export const getAccrual = async (accrualId: number): Promise<Accrual> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/Accrual/${accrualId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: Accrual = response.data
  return data
}

// GET: /Accrual/job/{jobid} - Get all accruals for a specific job
export const getAccrualsByJob = async (jobId: number): Promise<Accrual[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/Accrual/job/${jobId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: Accrual[] = response.data
  return data
}

// POST: /Accrual - Create a new accrual
export const createAccrual = async (accrual: PostAccrual): Promise<Accrual> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/Accrual`,
    method: 'post',
    data: {
      jobId: accrual.jobId,
      description: accrual.description,
      value: accrual.value,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: Accrual = response.data
  return data
}

// PUT: /Accrual/{id} - Update an existing accrual
export const updateAccrual = async (accrualId: number, accrual: UpdateAccrual): Promise<Accrual> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/Accrual/${accrualId}`,
    method: 'put',
    data: {
      accrualId: accrual.accrualId,
      jobId: accrual.jobId,
      description: accrual.description,
      value: accrual.value,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data: Accrual = response.data
  return data
}

// DELETE: /Accrual/{id} - Delete an accrual
export const deleteAccrual = async (accrualId: number): Promise<void> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  await axios({
    url: `https://${apiURL}/Accrual/${accrualId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
}
